export const languagesConfig = {
  'AIR': ['en', 'el', 'es', 'de', 'fr', 'pt'],
  'BRE': ['en', 'de'],
  'FMM': ['en', 'de'],
  'FM1': ['en', 'de'],
  'HER': ['en', 'el'],
  'NUE': ['en', 'de'],
  'PB1': ['en', 'de'],
  'SZG': ['en', 'de'],
};